module.exports = __webpack_public_path__ + "img/icon6.5b5270cf.png";